module.exports = __webpack_public_path__ + "img/UX.84c638d3.jpg";